<template>
  <section class="bm-huohao">
    <header class="bm-huohao__head">
      <div class="bm-huohao__crumb">
        <button @click="$emit('back')">‹ 返回</button>
        <span>
          云库工作台　›　批量修改　›
          <strong>货号</strong>
        </span>
        <a>帮助教程</a>
      </div>
      <h1>批量修改货号</h1>
      <nav>
        <button class="mode-range" :class="{ active: mode === 'range' }" @click="switchMode('range')">按范围修改</button>
        <button class="mode-goods" :class="{ active: mode === 'goods' }" @click="switchMode('goods')">按商品修改</button>
      </nav>
    </header>
    <main class="bm-huohao__body">
      <section v-if="mode === 'range'" class="bm-huohao__filter">
        <div v-for="field in fields" :key="field.key" class="bm-huohao__field">
          <label>{{ field.label }}</label>
          <el-select v-if="field.select || field.key === 'group_id' || field.key === 'child_group_id'"
            v-model="filterValues[field.key]" @change="field.key === 'group_id' && onGroupChange()"
            class="bm-huohao__filter-select">
            <el-option :label="field.placeholder" :value="''" />
            <el-option v-for="option in optionsFor(field.key)" :key="option.value" :label="option.label"
              :value="option.value" />
          </el-select>
          <div v-else-if="field.range" class="bm-huohao__date-range">
            <input v-model="addTime[0]" class="bm-huohao__date-input" type="date" aria-label="开始时间" />
            <span class="bm-huohao__date-separator">—</span>
            <input v-model="addTime[1]" class="bm-huohao__date-input" type="date" aria-label="结束时间" />
          </div>
          <input v-else :placeholder="field.placeholder" v-model="filterValues[field.key]" />
        </div>
        <footer>
          <div>
            <button @click="loadPreview()">查询</button>
            <button class="plain" @click="resetFilters">重置</button>
          </div>
        </footer>
      </section>
      <section v-else class="bm-huohao__picked">
        <button @click="openSelector">选择商品</button>
        <span>{{ selected.length ? '已选择 ' + selected.length + ' 个商品' : '请先选择需要修改的商品' }}</span>
      </section>
      <section class="bm-huohao__methods">
        <header>
          <i></i>
          修改内容
        </header>
        <article v-for="(method, index) in methods" :key="method.type">
          <el-checkbox v-model="method.on"
            @change="handleMethodChange(index)" class="bm-huohao__method-name">
            方式{{ index + 1 }}：{{ method.name }}
          </el-checkbox>
          <div class="bm-huohao__method-content">
            <template v-if="index === 0">
              <div class="bm-huohao__single-input">
                <input v-model="form.newHuohao" maxlength="50" placeholder="请输入新货号" />
                <small>{{ form.newHuohao.length }}/50</small>
              </div>
            </template>
            <template v-else-if="index === 1">
              <div class="bm-huohao__inline">
                <span>增加前缀内容:</span>
                <input v-model="form.prefix" placeholder="请输入前缀" />
                <span>增加后缀:</span>
                <input v-model="form.suffix" placeholder="请输入后缀" />
              </div>
            </template>
            <template v-else-if="index === 2">
              <div v-for="(replace, replaceIndex) in form.replaces" :key="replaceIndex" class="bm-huohao__replace">
                <span>关键字:</span>
                <input v-model="replace.find" placeholder="请输入关键字" />
                <span>替换为</span>
                <input v-model="replace.value" placeholder="替换后内容" />
                <button @click="addReplace">＋ 添加</button>
                <button v-if="replaceIndex" class="danger" @click="removeReplace(replaceIndex)">删除</button>
              </div>
            </template>
            <template v-else-if="index === 3">
              <div class="bm-huohao__multi-input">
                <textarea v-model="form.keywords" maxlength="100000" placeholder="请输入需要删除的关键词、多个关键词用逗号，分隔，最多100000个字"></textarea>
                <small>{{ form.keywords.length }}/100000</small>
              </div>
            </template>
            <template v-else-if="index === 4">
              <div class="bm-huohao__radio-group">
                <label class="bm-huohao__radio-label">
                  <input v-model="form.randomMode" value="all" type="radio" name="randomMode" class="bm-huohao__radio" />
                  <span>针对全部商品</span>
                </label>
                <label class="bm-huohao__radio-label">
                  <input v-model="form.randomMode" value="empty" type="radio" name="randomMode" class="bm-huohao__radio" />
                  <span>针对货号为空的商品</span>
                </label>
              </div>
            </template>
          </div>
        </article>
      </section>
      <section v-if="preview" class="bm-huohao__preview">
        <header>
          已选择 <b>{{ mode === 'goods' ? selected.length : previewPage.total }}</b> 个商品，当前预览
          <b>{{ previewPage.total }}</b>
          个，已排除 {{ excludedProductIds.length }} 个（当前页 {{ previewGoods.length }}）
          <button @click="preview = false">收起预览</button>
        </header>
        <table>
          <thead>
            <tr>
              <th>商品信息</th>
              <th>调整前货号</th>
              <th>调整后货号</th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(good, n) in previewGoods" :key="good.id || n" :class="{
              'is-excluded': excludedProductIds.includes(Number(good.id))
            }">
              <td>
                <el-image class="bm-huohao__image" :src="imageOf(good)" fit="cover" :preview-src-list="[imageOf(good)]"
                  alt="商品主图" />
                <div>
                  <small>商品ID：{{ good.id }}</small>
                  <small style="margin-left: 5px">来源ID：{{ good.source_product_id || '—' }}</small>
                  <small style="margin-left: 5px">数据源：{{ sourceLabel(good.source_web) }}</small>
                  <p>{{ good.title || '' }}</p>
                </div>
              </td>
              <td class="huohao-cell">
                <div class="huohao-display">{{ good.old_huohao || good.huohao || '—' }}</div>
              </td>
              <td class="huohao-cell">
                <textarea v-model="good.new_huohao" readonly></textarea>
              </td>
              <td class="action-cell">
                <button :class="{
                  restore: excludedProductIds.includes(Number(good.id))
                }" @click="toggleExclude(good)">
                  {{ excludedProductIds.includes(Number(good.id)) ? '恢复修改' : '排除修改' }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>
        <footer class="bm-huohao__pagination">
          <button :disabled="previewPage.page <= 1" @click="loadPreview(previewPage.page - 1)">上一页</button>
          <span>第 {{ previewPage.page }} / {{ pageCount }} 页</span>
          <button :disabled="previewPage.page >= pageCount" @click="loadPreview(previewPage.page + 1)">下一页</button>
          <select v-model.number="previewPage.limit" @change="loadPreview(1)">
            <option :value="10">10条/页</option>
            <option :value="20">20条/页</option>
            <option :value="50">50条/页</option>
          </select>
        </footer>
      </section>
    </main>
    <footer class="bm-huohao__bottom">
      <button class="preview" @click="loadPreview()">修改内容预览</button>
      <button class="start" :disabled="loading" @click="startBatch" title="点击预览检查无误后，再点击开始批量修改">开始批量修改</button>
    </footer>
    <div v-if="selecting" class="bm-huohao__mask">
      <div class="bm-huohao__select-modal">
        <header>
          <strong>选择修改商品</strong>
          <button @click="cancelSelection">×</button>
        </header>
        <nav>
          <button :class="{ active: selectorTab === 'all' }" @click="switchSelectorTab('all')">选择商品</button>
          <button :class="{ active: selectorTab === 'selected' }" @click="switchSelectorTab('selected')">已选择</button>
        </nav>
        <div class="bm-huohao__selector-toolbar">
          <div class="bm-huohao__select-filter">
            <el-select v-model="selectorFilters.group_id" popper-class="bm-huohao__select-popper"
              class="bm-huohao__group-select" placeholder="分组" @change="loadSelectorGroups">
              <el-option label="全部分组" value="" />
              <el-option v-for="group in groupList" :key="group.id" :label="group.name" :value="group.id" />
            </el-select>
            <el-select v-model="selectorFilters.child_group_id" popper-class="bm-huohao__select-popper"
              class="bm-huohao__group-select" placeholder="子分组" @change="loadGoods(1)">
              <el-option label="全部子分组" value="" />
              <el-option v-for="group in selectorChildGroups" :key="group.id" :label="group.name" :value="group.id" />
            </el-select>
            <input v-model="selectorFilters.source_product_id" placeholder="来源ID" />
            <input v-model="selectorFilters.keyword" placeholder="商品标题" />
            <button @click="loadGoods(1)">查询</button>
          </div>
          <div class="bm-huohao__selector-pagination">
            <button :disabled="selectorPage.page <= 1" @click="loadGoods(selectorPage.page - 1)">上一页</button>
            <span>{{ selectorPage.page }} / {{ Math.max(1, Math.ceil(selectorPage.total / selectorPage.limit)) }}</span>
            <button :disabled="selectorPage.page >= Math.max(1, Math.ceil(selectorPage.total / selectorPage.limit))"
              @click="loadGoods(selectorPage.page + 1)">下一页</button>
            <el-select v-model="selectorPage.limit" popper-class="bm-huohao__select-popper" class="bm-huohao__page-size"
              @change="loadGoods(1)">
              <el-option v-for="size in [10, 20, 50]" :key="size" :label="size + '条/页'" :value="size" />
            </el-select>
          </div>
          <label class="bm-huohao__select-all"><el-checkbox :value="selectorPageAllSelected" @change="togglePageGoods" />
            <span>全选</span></label>
        </div>
        <main>
          <button v-for="good in displayedGoods" :key="good.id"
            :class="{ selected: selected.includes(Number(good.product_id)) }" @click="toggleGood(good.product_id)">
            <el-checkbox :value="selected.includes(Number(good.product_id))" @click.native.stop @change="toggleGood(good.product_id)" />
            <img :src="imageOf(good)" alt="商品主图" />
            <span>{{ good.title || good.product_title }}</span>
            <small>{{ priceRange(good) }}</small>
          </button>
        </main>
        <footer>
          <span>已选 {{ selected.length }} 个商品</span>
          <button class="plain" @click="cancelSelection">取消</button>
          <button @click="selecting = false">确定</button>
        </footer>
      </div>
    </div>
    <div v-if="success" class="bm-huohao__mask">
      <div class="bm-huohao__small-modal">
        <header>
          <strong>提示</strong>
          <button @click="success = false">×</button>
        </header>
        <main class="success-message">
          <b>✓</b>
          <p>批量修改任务创建成功</p>
          <small>任务将在后台处理，请在批量修改记录中查看进度。</small>
        </main>
        <footer><button @click="success = false">我知道了</button></footer>
      </div>
    </div>
  </section>
</template>

<script>
import { createCloudHuohaoBatch, previewCloudHuohaoBatch } from '@/api/main/cloudBatchEdit'
import { cloudProductGroups, cloudProductList } from '@/api/main/ucenter'

const RULE_TYPES = [401, 402, 403, 404, 405]
const fields = [
  { key: 'group_id', label: '分组', placeholder: '请选择分组' },
  { key: 'child_group_id', label: '子分组', placeholder: '请选择子分组' },
  { key: 'created_range', label: '导入时间', range: true },
  { key: 'source_product_id', label: '来源ID', placeholder: '请输入来源ID' },
  {
    key: 'sku_status',
    label: 'SKU替换状态',
    select: true,
    placeholder: '全部'
  },
  {
    key: 'sku_mark_status',
    label: '商品标记状态',
    select: true,
    placeholder: '全部'
  },
  {
    key: 'ai_title_status',
    label: '标题替换状态',
    select: true,
    placeholder: '全部'
  },
  { key: 'source_web', label: '数据源', select: true, placeholder: '全部' }
]
const defaultFilterValues = {
  group_id: '',
  child_group_id: '',
  source_product_id: '',
  sku_status: '',
  sku_mark_status: '',
  ai_title_status: '',
  source_web: ''
}
export default {
  name: 'BatchModifyHuohao',
  data() {
    return {
      mode: 'range',
      fields,
      addTime: [],
      groupList: [],
      childGroupList: [],
      groupLoading: false,
      statusOptions: {
        sku_status: [],
        sku_mark_status: [],
        ai_title_status: [],
        source_web: []
      },
      filterValues: { ...defaultFilterValues },
      preview: false,
      previewGoods: [],
      previewPage: { page: 1, limit: 20, total: 0 },
      excludedProductIds: [],
      selecting: false,
      selectorTab: 'all',
      selectorLoading: false,
      selectorPage: { page: 1, limit: 20, total: 0 },
      selectorFilters: { group_id: '', child_group_id: '', source_product_id: '', keyword: '' },
      selectorChildGroups: [],
      selectedGoods: [],
      success: false,
      loading: false,
      selected: [],
      methods: [
        '统一设置货号为', '增加前缀/后缀', '关键字替换', '删除关键字', '随机生成货号'
      ].map((name, index) => ({ type: RULE_TYPES[index], name, on: index === 0 })),
      form: {
        newHuohao: '',
        prefix: '',
        suffix: '',
        replaces: [{ find: '', value: '' }],
        keywords: '',
        randomMode: 'all'
      },
      goods: []
    }
  },
  computed: {
    displayedGoods() {
      if (this.selectorTab !== 'selected') return this.goods
      const start = (this.selectorPage.page - 1) * this.selectorPage.limit
      return this.selectedGoods.slice(start, start + this.selectorPage.limit)
    },
    selectorPageAllSelected() {
      const list = this.displayedGoods
      return list.length > 0 && list.every((good) => this.selected.includes(Number(good.product_id)))
    },
    pageCount() {
      const total = Number(this.previewPage.total)
      const limit = Number(this.previewPage.limit)
      return Number.isFinite(total) && Number.isFinite(limit) && limit > 0
        ? Math.max(1, Math.ceil(total / limit))
        : 1
    }
  },
  created() {
    this.loadGroups()
  },
  methods: {
    switchMode(mode) {
      if (this.mode === mode) return
      this.mode = mode
      this.preview = false
      this.previewGoods = []
      this.excludedProductIds = []
      this.previewPage = { ...this.previewPage, page: 1, total: 0 }
    },
    async openSelector() {
      this.selecting = true
      if (!this.groupList.length) await this.loadGroups()
      this.loadSelectorGroups()
    },
    switchSelectorTab(tab) {
      this.selectorTab = tab
      if (tab === 'selected') {
        this.selectorPage = { ...this.selectorPage, page: 1, total: this.selectedGoods.length }
        return
      }
      this.loadGoods(1)
    },
    loadSelectorGroups() {
      const group = this.groupList.find((item) => String(item.id) === String(this.selectorFilters.group_id))
      this.selectorChildGroups = ((group && group.child_groups) || []).map((item) => ({ ...item, id: item.id ?? item.group_id ?? item.child_group_id, name: item.name ?? item.group_name ?? item.child_group_name }))
      this.selectorFilters.child_group_id = ''
      this.loadGoods(1)
    },
    async loadGoods(page = 1) {
      if (this.selectorTab === 'selected') {
        const maxPage = Math.max(1, Math.ceil(this.selectedGoods.length / this.selectorPage.limit))
        this.selectorPage = { ...this.selectorPage, page: Math.min(page, maxPage), total: this.selectedGoods.length }
        return
      }
      this.selectorLoading = true
      try {
        const params = { page, page_size: this.selectorPage.limit, 'status': 1, ...this.selectorFilters }
        const response = await cloudProductList(params)
        const root = response && response.data ? response.data : response
        const list = Array.isArray(root) ? root : (root.list || root.data || [])
        // 确保每个商品有 product_id 字段
        this.goods = list.map(item => ({
          ...item,
          product_id: item.product_id
        }))
        const total = root.total !== undefined ? Number(root.total) : this.goods.length
        this.selectorPage = { page, limit: this.selectorPage.limit, total }
      } catch (e) {
        this.$message.error('商品查询失败')
      } finally {
        this.selectorLoading = false
      }
    },
    togglePageGoods(checked) {
      this.displayedGoods.forEach((good) => {
        const id = Number(good.product_id)
        if (!id || isNaN(id)) return
        if (checked && !this.selected.includes(id)) {
          this.selected.push(id)
          this.selectedGoods.push(good)
        }
        if (!checked) {
          const i = this.selected.indexOf(id)
          if (i >= 0) this.selected.splice(i, 1)
          this.selectedGoods = this.selectedGoods.filter((x) => Number(x.product_id) !== id)
        }
      })
    },
    cancelSelection() {
      this.selected = []
      this.selectedGoods = []
      this.selecting = false
    },
    priceRange(good) {
      const min = good.min_price ?? good.price_min ?? good.price
      const max = good.max_price ?? good.price_max ?? min
      return min === undefined || min === null ? '价格待定' : `¥${min}~¥${max}`
    },
    handleMethodChange(index) {
      // 点击某个方式时，取消其他所有方式的选中状态
      this.methods.forEach((method, i) => {
        if (i !== index) {
          method.on = false
        }
      })
    },
    async loadGroups() {
      this.groupLoading = true
      try {
        const r = await cloudProductGroups({ with_count: 0 })
        const data = (r.data && (r.data.data || r.data)) || []
        this.groupList = (Array.isArray(data) ? data : []).map((group) => ({ ...group, id: group.id ?? group.group_id, name: group.name ?? group.group_name, child_groups: group.child_groups || group.children || group.sub_groups || [] }))
        this.statusOptions = {
          sku_status: [
            { label: '待替换', value: 1 },
            { label: '已替换', value: 2 },
            { label: '找不到', value: 3 }
          ],
          sku_mark_status: [
            { label: '未标记', value: 1 },
            { label: '已标记', value: 2 },
            { label: '找不到', value: 3 }
          ],
          ai_title_status: [
            { label: '待替换', value: 1 },
            { label: '已替换', value: 2 },
            { label: '异常', value: 9 }
          ],
          source_web: [
            { value: 9, label: '星好货' },
            { value: 3, label: 'TB' },
            { value: 4, label: 'PDD' },
            { value: 2, label: '1688' },
            { value: 5, label: 'DY' },
            { value: 6, label: 'WX' }
          ]
        }
      } catch (e) {
        this.$message.error('分组加载失败')
      } finally {
        this.groupLoading = false
      }
    },
    optionsFor(key) {
      if (key === 'group_id') return this.groupList.map((i) => ({ value: i.id, label: i.name }))
      if (key === 'child_group_id') return this.childGroupList.map((i) => ({ value: i.id, label: i.name }))
      return this.statusOptions[key] || []
    },
    onGroupChange() {
      this.filterValues.child_group_id = ''
      const group = this.groupList.find((i) => String(i.id) === String(this.filterValues.group_id))
      this.childGroupList = (group && (group.child_groups || group.children || [])) || []
    },
    resetFilters() {
      this.filterValues = { ...defaultFilterValues }
      this.addTime = []
      this.childGroupList = []
    },
    buildQueryPayload() {
      const productFilter = { ...this.filterValues }
      delete productFilter.created_range
      if (this.addTime && this.addTime.length === 2) {
        productFilter.created_start = this.addTime[0]
        productFilter.created_end = this.addTime[1]
      } else {
        delete productFilter.created_start
        delete productFilter.created_end
      }
      if (this.mode === 'goods') {
        productFilter.product_ids = this.selected
      }
      productFilter.excluded_product_ids = this.excludedProductIds

      return {
        product_filter: productFilter,
        rules: this.methods
          .filter((m) => m.on)
          .map((m) => ({ type: m.type, options: this.ruleOptions(m.type) }))
      }
    },
    ruleOptions(type) {
      const map = {
        401: ['newHuohao'],
        402: ['prefix', 'suffix'],
        403: ['replaces'],
        404: ['keywords'],
        405: ['randomMode']
      }
      const options = (map[type] || []).reduce((result, key) => ({ ...result, [key]: this.form[key] }), {})

      // 特殊处理：将 randomMode 映射为 mode（后端期望的字段名）
      if (type === 405 && options.randomMode) {
        options.mode = options.randomMode
        delete options.randomMode
      }

      return options
    },
    parsePageResponse(response) {
      const root =
        response && response.data && !Array.isArray(response.data) && (response.data.data || response.data.list)
          ? response.data
          : response
      const page =
        root && root.data && !Array.isArray(root.data) && (root.data.data || root.data.list) ? root.data : root
      const list = Array.isArray(page) ? page : (page && (page.data || page.list)) || []
      return {
        list,
        total: page && page.total !== undefined ? Number(page.total) : list.length,
        page: page && (page.current_page || page.currentPage)
          ? Number(page.current_page || page.currentPage)
          : null,
        limit: Number((page && (page.per_page || page.perPage)) || this.previewPage.limit)
      }
    },
    async loadPreview(page = 1) {
      if (this.loading) return

      // 前端校验
      const validationError = this.validateForm()
      if (validationError) {
        this.$message.warning(validationError)
        return
      }

      if (this.mode === 'goods' && !this.selected.length) {
        this.$message.warning('请先选择商品')
        return
      }
      const requestedPage = Number(page)
      const target = Math.min(
        Math.max(1, Number.isFinite(requestedPage) ? requestedPage : 1),
        this.pageCount
      )
      this.loading = true
      try {
        const r = await previewCloudHuohaoBatch({
          ...this.buildQueryPayload(),
          page: target,
          limit: this.previewPage.limit
        })
        const result = this.parsePageResponse(r)
        this.previewGoods = result.list
        this.previewPage = {
          page: result.page || target,
          limit: result.limit || this.previewPage.limit,
          total: result.total
        }
        this.preview = true
      } catch (e) {
        this.$message.error(this.errorMessage(e, '查询失败'))
      } finally {
        this.loading = false
      }
    },
    async startBatch() {
      if (this.loading) return

      // 检查商品数量
      const totalProducts = this.previewPage?.total || 0
      if (totalProducts <= 0) {
        this.$message.warning('商品数小于0，请选择商品后点击修改预览')
        return
      }

      // 弹出确认提示
      try {
        await this.$confirm(`商品数${totalProducts}，是否开始修改？`, '确认修改', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
      } catch (e) {
        // 用户点击取消
        return
      }

      // 前端校验
      const validationError = this.validateForm()
      if (validationError) {
        this.$message.warning(validationError)
        return
      }

      this.loading = true
      try {
        const response = await createCloudHuohaoBatch(this.buildQueryPayload())
        if (response && response.code !== undefined && Number(response.code) !== 200) {
          throw new Error(response.message || '创建任务失败')
        }
        this.success = true
        this.$emit('created')
      } catch (e) {
        this.$message.error(this.errorMessage(e, '创建任务失败'))
      } finally {
        this.loading = false
      }
    },
    imageOf(good) {
      return (
        good.main_image ||
        good.image_url ||
        (Array.isArray(good.main_images) ? good.main_images[0] : '') ||
        "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='52' height='52'%3E%3Crect width='100%' height='100%' fill='%23f5f5f5'/%3E%3Ctext x='50%' y='55%' text-anchor='middle' fill='%23999' font-size='10'%3E暂无图片%3C/text%3E%3C/svg%3E"
      )
    },
    errorMessage(error, fallback) {
      return error?.response?.data?.message || error?.response?.data?.msg || error?.message || fallback
    },
    sourceLabel(value) {
      const item = this.statusOptions.source_web.find((i) => String(i.value) === String(value))
      return item ? item.label : value || '未知'
    },
    toggleExclude(good) {
      const id = Number(good.id)
      this.excludedProductIds = this.excludedProductIds.includes(id)
        ? this.excludedProductIds.filter((item) => item !== id)
        : [...this.excludedProductIds, id]
    },
    toggleGood(id) {
      id = Number(id)
      if (!id || isNaN(id)) return
      const i = this.selected.indexOf(id)
      if (i >= 0) {
        this.selected.splice(i, 1)
        this.selectedGoods = this.selectedGoods.filter((good) => Number(good.product_id) !== id)
      } else {
        this.selected.push(id)
        const good = this.goods.find((x) => Number(x.product_id) === id)
        if (good) this.selectedGoods.push(good)
      }
    },
    addReplace() {
      this.form.replaces.push({ find: '', value: '' })
    },
    removeReplace(index) {
      this.form.replaces.splice(index, 1)
    },
    validateForm() {
      // 检查是否选择了至少一种修改方式
      const selectedMethod = this.methods.find((m) => m.on)
      if (!selectedMethod) {
        return '请至少选择一种修改方式'
      }

      const selectedIndex = this.methods.findIndex((m) => m.on)

      // 方式1: 统一设置货号为
      if (selectedIndex === 0) {
        if (!this.form.newHuohao || this.form.newHuohao.trim() === '') {
          return '请输入新货号'
        }
      }

      // 方式2: 增加前缀/后缀
      if (selectedIndex === 1) {
        if ((!this.form.prefix || this.form.prefix.trim() === '') &&
            (!this.form.suffix || this.form.suffix.trim() === '')) {
          return '请至少输入前缀或后缀内容'
        }
      }

      // 方式3: 关键字替换
      if (selectedIndex === 2) {
        const validReplaces = this.form.replaces.filter((r) => r.find && r.find.trim() !== '')
        if (validReplaces.length === 0) {
          return '请至少添加一组关键字替换规则'
        }
        // 检查每个替换规则是否完整
        for (let i = 0; i < this.form.replaces.length; i++) {
          const replace = this.form.replaces[i]
          if (replace.find && replace.find.trim() !== '') {
            // 如果填写了查找内容，替换内容可以为空（表示删除）
            continue
          } else if (replace.value && replace.value.trim() !== '') {
            return `第 ${i + 1} 组替换规则：请输入要查找的关键字`
          }
        }
      }

      // 方式4: 删除关键字
      if (selectedIndex === 3) {
        if (!this.form.keywords || this.form.keywords.trim() === '') {
          return '请输入需要删除的关键词'
        }
      }

      // 方式5: 随机生成货号
      if (selectedIndex === 4) {
        if (!this.form.randomMode) {
          return '请选择随机生成货号的范围'
        }
      }

      return null
    }
  }
}
</script>

<style scoped>
/* 复用 BatchModifyTitle 的样式，只需替换 bm-title 为 bm-huohao */
.bm-huohao {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
  min-height: calc(100vh - 56px);
  overflow-x: hidden;
  background: #f5f6f8;
  color: #1a1a2e;
  font-family: 'Noto Sans SC', sans-serif;
}

.bm-huohao__preview tr:nth-child(even) {
  background: #fcfcfd;
}

.bm-huohao__preview tr:hover {
  background: #f0f7ff;
}

.bm-huohao__preview tr.is-excluded {
  background: #e5e5e5;
  color: #777;
}

.bm-huohao button,
.bm-huohao input,
.bm-huohao select,
.bm-huohao textarea {
  font: inherit;
}

.bm-huohao button {
  cursor: pointer;
}

.bm-huohao__head {
  background: #fff;
  border-bottom: 1px solid #e0e0ec;
  padding: 10px 20px 0;
}

.bm-huohao__crumb {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: #999;
}

.bm-huohao__crumb button {
  height: 26px;
  padding: 0 10px;
  border: 1px solid #e0e0ec;
  border-radius: 4px;
  background: #fff;
  color: #666;
}

.bm-huohao__crumb a {
  margin-left: auto;
  color: #1677ff;
}

.bm-huohao h1 {
  margin: 12px 0 8px;
  font: 600 18px 'Noto Serif SC', serif;
}

.bm-huohao__head nav {
  display: flex;
  gap: 22px;
}

.bm-huohao__head nav button {
  padding: 9px 6px;
  border: 0;
  border-bottom: 2px solid transparent;
  background: #fff;
  color: #666;
  font-size: 13px;
}

.bm-huohao__head nav button.active {
  border-bottom-color: #c8443c;
  color: #c8443c;
  font-weight: 600;
}

.bm-huohao__body {
  padding: 14px 20px 82px;
}

.bm-huohao__filter {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 10px 14px;
  padding: 14px 16px 10px;
  border: 2px solid #e0e0ec;
  border-radius: 8px;
  background: #fff;
}

.bm-huohao__field label {
  display: block;
  margin-bottom: 4px;
  color: #666;
  font-size: 10px;
}

.bm-huohao__field input,
.bm-huohao__field select,
.bm-huohao__method-content input,
.bm-huohao__method-content select,
.bm-huohao__method-content textarea {
  box-sizing: border-box;
  width: 100%;
  height: 28px;
  padding: 4px 8px;
  border: 1px solid #e0e0ec;
  border-radius: 4px;
  background: #fff;
  font-size: 11px;
}

.bm-huohao__date-range {
  display: flex;
  align-items: center;
  width: 100%;
  min-width: 0;
  gap: 5px;
}

.bm-huohao__date-input {
  flex: 1 1 0;
  min-width: 0;
  box-sizing: border-box;
  width: 0;
  height: 28px;
  padding: 4px 8px;
  border: 1px solid #e0e0ec;
  border-radius: 4px;
  background: #fff;
  color: #666;
  font-size: 11px;
}

.bm-huohao__date-separator {
  flex: 0 0 12px;
  color: #999;
  text-align: center;
}

.bm-huohao__filter footer {
  grid-column: 1/-1;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
  padding-top: 9px;
  border-top: 1px solid #f0f0f0;
  font-size: 12px;
}

.bm-huohao__filter button,
.bm-huohao__picked button,
.bm-huohao__small-modal footer button,
.bm-huohao__select-modal footer button {
  height: 28px;
  padding: 0 13px;
  border: 0;
  border-radius: 4px;
  background: #c8443c;
  color: #fff;
  font-size: 12px;
}

.bm-huohao__filter .plain {
  border: 1px solid #e0e0ec;
  background: #fff;
  color: #666;
}

.bm-huohao__picked {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 14px;
  padding: 10px 14px;
  border: 1px solid #e0e0ec;
  border-radius: 6px;
  background: #fff;
  color: #666;
  font-size: 12px;
}

.bm-huohao__picked button {
  background: #1677ff;
}

.bm-huohao__picked span {
  color: #1677ff;
}

.bm-huohao__methods {
  overflow: hidden;
  margin-top: 14px;
  border: 2px solid #e0e0ec;
  border-radius: 8px;
  background: #fff;
}

.bm-huohao__methods>header {
  padding: 10px 14px;
  border-bottom: 1px solid #e0e0ec;
  background: #f5f0e8;
  font-size: 12px;
  font-weight: 600;
}

.bm-huohao__methods>header i {
  display: inline-block;
  width: 3px;
  height: 14px;
  margin-right: 7px;
  border-radius: 2px;
  background: #c8443c;
  vertical-align: middle;
}

.bm-huohao__methods article {
  padding: 12px 14px;
  border-bottom: 1px solid #e0e0ec;
  font-size: 12px;
}

.bm-huohao__methods article:last-child {
  border-bottom: 0;
}

.bm-huohao__method-name {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  color: #1a1a2e;
  font-size: 13px;
  font-weight: 600;
  line-height: 18px;
  cursor: pointer;
}

.bm-huohao__method-content {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin: 10px 0 0 22px;
  color: #666;
}

.bm-huohao__method-content input[type='checkbox'],
.bm-huohao__method-content input[type='radio'] {
  width: 14px;
  height: 14px;
  min-width: 14px;
  margin: 0;
  padding: 0;
  accent-color: #1677ff;
  cursor: pointer;
  -webkit-appearance: auto;
  appearance: auto;
  border: 1px solid #d9c98d;
}

.bm-huohao__radio-group {
  display: flex;
  gap: 20px;
  align-items: center;
}

.bm-huohao__radio-label {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
}

.bm-huohao__radio {
  flex-shrink: 0;
}

.bm-huohao__method-content>label {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  white-space: nowrap;
  cursor: pointer;
}

.bm-huohao__method-content>span {
  flex-shrink: 0;
  color: #666;
  font-size: 12px;
}

.bm-huohao__method-content input[type='text'],
.bm-huohao__method-content input:not([type='checkbox']):not([type='radio']) {
  width: 190px;
}

.bm-huohao__method-content input.long {
  width: 360px;
}

.bm-huohao__method-content textarea {
  width: 100%;
  max-width: 600px;
  min-height: 80px;
  height: auto;
  resize: vertical;
  line-height: 1.5;
}

.bm-huohao__method-content small {
  color: #999;
  font-size: 10px;
}

.bm-huohao__single-input {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.bm-huohao__single-input input {
  width: 500px;
  padding-right: 8px;
}

.bm-huohao__single-input small {
  flex-shrink: 0;
  color: #999;
  font-size: 10px;
}

.bm-huohao__multi-input {
  position: relative;
  width: 100%;
  max-width: 600px;
}

.bm-huohao__multi-input textarea {
  width: 100%;
  max-width: 600px;
  min-height: 80px;
  padding-right: 8px;
  padding-bottom: 20px;
}

.bm-huohao__multi-input small {
  position: absolute;
  right: 8px;
  bottom: 8px;
  color: #999;
  font-size: 10px;
}

.bm-huohao__count-input,
.bm-huohao__count-textarea {
  position: relative;
  width: fit-content;
  max-width: 600px;
  line-height: normal;
}

.bm-huohao__count-input input {
  width: 360px;
  padding-right: 60px;
}

.bm-huohao__count-input small,
.bm-huohao__count-textarea small {
  position: absolute;
  right: 8px;
  bottom: 8px;
  color: #999;
  font: 10px 'JetBrains Mono', monospace;
  background: rgba(255, 255, 255, 0.9);
  padding: 2px 4px;
  border-radius: 2px;
}

.bm-huohao__count-textarea textarea {
  width: 100%;
  min-height: 80px;
  padding: 8px;
  padding-bottom: 24px;
  box-sizing: border-box;
}

.bm-huohao__inline {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
}

.bm-huohao__inline input:not([type='checkbox']):not([type='radio']) {
  width: 200px;
}

.bm-huohao__replace {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
}

.bm-huohao__replace input {
  width: 160px;
}

.bm-huohao__replace button {
  height: 28px;
  padding: 0 10px;
  border: 1px solid #91caff;
  border-radius: 4px;
  background: #e6f4ff;
  color: #1677ff;
  font-size: 11px;
}

.bm-huohao__replace .danger {
  border-color: #ffccd2;
  background: #fff5f5;
  color: #c8443c;
}

.bm-huohao__preview {
  overflow: hidden;
  margin-top: 14px;
  border: 2px solid #e0e0ec;
  border-radius: 8px;
  background: #fff;
}

.bm-huohao__preview header {
  padding: 10px 14px;
  border-bottom: 1px solid #e0e0ec;
  font-size: 12px;
}

.bm-huohao__preview header b {
  color: #1677ff;
}

.bm-huohao__preview header button {
  float: right;
  border: 0;
  background: none;
  color: #c8443c;
}

.bm-huohao__preview table {
  width: 100%;
  border-collapse: collapse;
}

.bm-huohao__preview th {
  padding: 8px 12px;
  background: #f5f0e8;
  color: #666;
  font-size: 11px;
  font-weight: 500;
  text-align: left;
}

.bm-huohao__preview td {
  padding: 10px 12px;
  border-bottom: 1px solid #f0f0f0;
  font-size: 11px;
}

.bm-huohao__preview td:first-child {
  display: flex;
  align-items: center;
  gap: 8px;
}

.bm-huohao__preview p {
  margin: 3px 0 0;
}

.bm-huohao__preview small {
  color: #999;
}

.bm-huohao__preview textarea {
  width: 100%;
  min-height: 38px;
  box-sizing: border-box;
  border: 1px solid #e0e0ec;
  border-radius: 4px;
  font-size: 11px;
}

.bm-huohao__preview .huohao-cell {
  min-width: 200px;
  max-width: 300px;
}

.bm-huohao__preview .huohao-cell textarea {
  width: 100%;
  min-width: 200px;
  padding: 5px;
  line-height: 1.4;
  background: #fafcff;
  resize: vertical;
}

.bm-huohao__preview .huohao-display {
  padding: 8px;
  min-height: 38px;
  word-break: break-all;
  line-height: 1.4;
  color: #666;
  background: #f5f5f5;
  border-radius: 4px;
}

.bm-huohao__preview td button {
  height: 24px;
  border: 1px solid #91caff;
  border-radius: 3px;
  background: #e6f4ff;
  color: #1677ff;
  font-size: 10px;
}

.bm-huohao__preview .action-cell {
  min-width: 110px;
  white-space: nowrap;
  text-align: center;
  vertical-align: middle;
}

.bm-huohao__preview .action-cell button {
  min-width: 82px;
  height: 30px;
  padding: 0 12px;
  border-color: #91caff;
  border-radius: 5px;
  background: #e6f4ff;
  color: #1677ff;
  font-size: 12px;
  line-height: 28px;
  transition: 0.2s;
}

.bm-huohao__preview .action-cell button:hover,
.bm-huohao__preview .action-cell button:focus {
  border-color: #409eff;
  background: #bae0ff;
  color: #0958d9;
}

.bm-huohao__preview .action-cell button.restore {
  border-color: #ffd591;
  background: #fff7e6;
  color: #d46b08;
}

.bm-huohao__preview .action-cell button.restore:hover,
.bm-huohao__preview .action-cell button.restore:focus {
  border-color: #ffa940;
  background: #ffe7ba;
  color: #ad4e00;
}

.bm-huohao__image {
  display: inline-flex;
  position: relative;
  z-index: 1;
  width: 46px;
  height: 46px;
  align-items: center;
  justify-content: center;
  border: 1px solid #ffccd2;
  border-radius: 4px;
  background: #fff5f5;
  object-fit: cover;
  font-size: 16px;
  cursor: pointer;
}

.bm-huohao__pagination {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  padding: 10px 14px;
  border-top: 1px solid #f0f0f0;
  color: #666;
  font-size: 12px;
}

.bm-huohao__pagination button {
  padding: 4px 10px;
  border: 1px solid #d9e2f0;
  border-radius: 4px;
  background: #fff;
  color: #1677ff;
}

.bm-huohao__pagination button:disabled {
  color: #bbb;
  cursor: not-allowed;
}

.bm-huohao__pagination select {
  height: 26px;
  border: 1px solid #d9e2f0;
  border-radius: 4px;
}

.bm-huohao__bottom {
  position: fixed;
  left: var(--merchant-sidebar-width, 210px);
  right: 0;
  z-index: 20;
  bottom: 0;
  display: flex;
  width: auto;
  max-width: none;
  min-width: 0;
  box-sizing: border-box;
  overflow-x: hidden;
  flex-wrap: nowrap;
  align-items: center;
  gap: 10px;
  padding: 10px 20px;
  border-top: 1px solid #e0e0ec;
  background: #fff;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.06);
  font-size: 12px;
}

.bm-huohao__bottom button {
  min-width: 0;
  flex: 0 1 auto;
  height: 30px;
  padding: 0 14px;
  border: 0;
  border-radius: 4px;
  color: #fff;
}

.bm-huohao__bottom .preview {
  background: #1677ff;
}

.bm-huohao__bottom .start {
  margin-left: auto;
  margin-right: 50px;
  padding: 0 28px;
  background: #52c41a;
}

.bm-huohao__mask {
  position: fixed;
  z-index: 3000;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(3px);
}

.bm-huohao__select-modal,
.bm-huohao__small-modal {
  width: min(1180px, 96vw);
  min-width: 900px;
  overflow: hidden;
  border: 1px solid #e0e0ec;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.18);
}

.bm-huohao__small-modal {
  width: min(400px, 100%);
  min-width: 0;
}

.bm-huohao__select-modal>header,
.bm-huohao__small-modal>header {
  display: flex;
  justify-content: space-between;
  padding: 12px 18px;
  border-bottom: 1px solid #e0e0ec;
  background: #fafafa;
  font-size: 14px;
}

.bm-huohao__select-modal>header button,
.bm-huohao__small-modal>header button {
  width: 24px;
  height: 24px;
  border: 1px solid #e0e0ec;
  border-radius: 4px;
  background: #fff;
  color: #666;
  font-size: 18px;
}

.bm-huohao__select-modal nav {
  display: flex;
  padding: 0 18px;
  border-bottom: 1px solid #e0e0ec;
}

.bm-huohao__select-modal nav button {
  padding: 10px 14px;
  border: 0;
  border-bottom: 2px solid transparent;
  background: #fff;
  color: #666;
  font-size: 12px;
}

.bm-huohao__select-modal nav button.active {
  border-bottom-color: #1677ff;
  color: #1677ff;
}

.bm-huohao__selector-toolbar {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 18px;
  background: #fafafa;
}

.bm-huohao__selector-toolbar .bm-huohao__select-filter {
  flex: 1;
  padding: 0;
  background: transparent;
}

.bm-huohao__select-filter {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.bm-huohao__select-filter input {
  width: 150px;
  height: 28px;
  padding: 4px 8px;
  border: 1px solid #e0e0ec;
  border-radius: 4px;
  background: #fff;
  font-size: 11px;
  line-height: 18px;
  box-sizing: border-box;
}

.bm-huohao__select-filter button {
  height: 28px;
  padding: 0 12px;
  border: 0;
  border-radius: 4px;
  background: #1677ff;
  color: #fff;
  font-size: 11px;
}

.bm-huohao__group-select {
  width: 108px;
}

.bm-huohao__page-size {
  width: 96px;
}

.bm-huohao__selector-pagination {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  padding: 0;
  color: #666;
  font-size: 12px;
}

.bm-huohao__selector-pagination button {
  padding: 3px 8px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  background: #fff;
  color: #606266;
}

.bm-huohao__selector-pagination button:disabled {
  cursor: not-allowed;
  opacity: .5;
}

.bm-huohao__select-all {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  margin-left: auto;
  white-space: nowrap;
  gap: 6px;
  font-size: 12px;
}

.bm-huohao__select-modal main {
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  gap: 10px;
  max-height: 350px;
  padding: 14px 18px;
  overflow: auto;
}

.bm-huohao__select-modal main button {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 8px;
  border: 2px solid #e0e0ec;
  border-radius: 6px;
  background: #fff;
  color: #1a1a2e;
  text-align: left;
  min-height: 150px;
}

.bm-huohao__select-modal main button.selected {
  border-color: #1677ff;
  background: #e6f4ff;
}

.bm-huohao__select-modal main img {
  width: 100%;
  height: 159px;
  object-fit: contain;
  background: #fff5f5;
}

.bm-huohao__select-modal main span {
  overflow: hidden;
  font-size: 10px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.bm-huohao__select-modal main small {
  color: #999;
  font-size: 10px;
}

.bm-huohao__select-modal footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  align-items: center;
  padding: 10px 18px;
  border-top: 1px solid #e0e0ec;
  font-size: 12px;
}

.bm-huohao__select-modal footer>span {
  margin-right: auto;
}

.bm-huohao__select-modal footer button {
  background: #1677ff;
}

.bm-huohao__select-modal footer .plain {
  border: 1px solid #e0e0ec;
  background: #fff;
  color: #666;
}

.bm-huohao__small-modal main {
  padding: 24px 20px;
  font-size: 13px;
}

.bm-huohao__small-modal footer {
  display: flex;
  justify-content: center;
  gap: 8px;
  padding: 12px 18px;
  border-top: 1px solid #e0e0ec;
}

.bm-huohao__small-modal footer button {
  width: 120px;
  height: 32px;
  border: 0;
  border-radius: 6px;
  background: #1677ff;
  color: #fff;
  font-size: 13px;
  font-weight: 600;
}

.bm-huohao__small-modal .success-message {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.bm-huohao__small-modal .success-message b {
  display: flex;
  width: 48px;
  height: 48px;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #f6ffed;
  color: #52c41a;
  font-size: 28px;
}

.bm-huohao__small-modal .success-message p {
  margin: 12px 0 5px;
}

.bm-huohao__small-modal .success-message small {
  color: #999;
}

::v-deep(.bm-huohao__methods .el-checkbox__inner) {
  width: 14px;
  height: 14px;
  border-color: #d9c98d;
  border-radius: 3px;
}

::v-deep(.bm-huohao__methods .el-checkbox__inner:hover),
::v-deep(.bm-huohao__methods .el-checkbox__input.is-focus .el-checkbox__inner) {
  border-color: #d4a946;
}

::v-deep(.bm-huohao__methods .el-checkbox__input.is-checked .el-checkbox__inner),
::v-deep(.bm-huohao__methods .el-checkbox__input.is-indeterminate .el-checkbox__inner) {
  border-color: #d4a946;
  background: #d4a946;
}

::v-deep(.bm-huohao__methods .el-checkbox__label) {
  color: #1a1a2e;
  font-size: 12px;
}

::v-deep(.bm-huohao__methods .el-checkbox__input.is-checked + .el-checkbox__label) {
  color: #1a1a2e;
}

::v-deep(.bm-huohao__image .el-image__inner) {
  border-radius: 4px;
  cursor: pointer;
}

.bm-huohao__filter-select {
  display: block;
  width: 100%;
}

::v-deep(.bm-huohao__filter-select .el-input__inner),
::v-deep(.bm-huohao__group-select .el-input__inner),
::v-deep(.bm-huohao__page-size .el-input__inner) {
  height: 28px;
  padding: 0 28px 0 8px;
  border-color: #e0e0ec;
  border-radius: 4px;
  color: #1a1a2e;
  font-size: 12px;
  line-height: 28px;
  text-align: left;
}

::v-deep(.bm-huohao__filter-select .el-input__suffix),
::v-deep(.bm-huohao__group-select .el-input__suffix),
::v-deep(.bm-huohao__page-size .el-input__suffix) {
  right: 7px;
}

::v-deep(.bm-huohao__filter-select .el-input__icon),
::v-deep(.bm-huohao__group-select .el-input__icon),
::v-deep(.bm-huohao__page-size .el-input__icon) {
  color: #999;
  font-size: 14px;
  line-height: 28px;
}

::v-deep(.bm-huohao__filter-select .el-input__inner:focus),
::v-deep(.bm-huohao__group-select .el-input__inner:focus),
::v-deep(.bm-huohao__page-size .el-input__inner:focus) {
  border-color: #d4a946;
}

@media (max-width: 960px) {
  .bm-huohao__filter {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .bm-huohao__select-modal {
    min-width: 0;
  }

  .bm-huohao__select-modal main {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .bm-huohao__selector-toolbar {
    flex-wrap: wrap;
  }
}

@media (max-width: 720px) {
  .bm-huohao__filter {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .bm-huohao__select-modal main {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .bm-huohao__bottom .start {
    margin-left: 0;
  }
}

@media (max-width: 520px) {

  .bm-huohao__head,
  .bm-huohao__body {
    padding-right: 12px;
    padding-left: 12px;
  }

  .bm-huohao__filter {
    grid-template-columns: 1fr;
  }

  .bm-huohao__method-content input,
  .bm-huohao__method-content input.long,
  .bm-huohao__method-content textarea {
    width: 100%;
  }

  .bm-huohao__select-modal main {
    grid-template-columns: repeat(2, 1fr);
  }

  .bm-huohao__bottom {
    left: 0;
    gap: 6px;
    padding: 8px 12px;
  }

  .bm-huohao__bottom .start {
    padding: 0 12px;
  }

  .bm-huohao__bottom .preview {
    display: none;
  }
}
</style>

<style>
.el-popper.bm-huohao__select-popper {
  z-index: 4000 !important;
}
</style>
